const defaultTitle = 'testdrive'
const environment = window.config ? window.config.environment : 'local'

export default (to, from, next) => {
  // collect environment
  let env = environment === 'prod' ? '' : `[${environment}]`

  // set default
  document.title = `${defaultTitle} ${env}`.trim()

  if (to.name) {
    document.title = `${to.name} - ${defaultTitle} ${env}`.trim()
  }
}



// WEBPACK FOOTER //
// ./src/router/title.js